"use client";

import { AccordionItems } from "./AccordionItems";
import type { AccordionItemProps } from "./AccordionItems";

const AccordionClient = (props: AccordionItemProps) => {
  return <AccordionItems {...props} />;
};

export default AccordionClient;
